<template>
    <div v-if="shouldShowItem" :is="tag" v-model="showButton" @keydown.tab="tabFocus" class="product-suggest__item-wrap" :class="{'product-suggest__item-wrap-cols': showAddToCartButton, 'product-suggest--family': item.matchType && item.matchType.includes('family'), 'cdp-item': item.cdp_item, 'slider-has-ratings': sliderHasStarRatings, 'slider-has-promos': sliderHasPromos}" :data-feed-identifier="resolveFeedIdentifier">
        <a
            :href="itemUrl"
            @click="itemClicked"
            :data-log="loggingAction"
            class="product-suggest__item"
            :class="{'has-wide-image': wideImage}"
            :aria-label="isCompareItem ? productLinkAriaLabel : undefined"
            :aria-labelledby="isCompareItem ? undefined : nameId"
            :aria-describedby="isCompareItem ? undefined : describedByIds"
        >
            <div class="product-suggest__item-inner" :aria-hidden="isCompareItem ? 'true' : undefined">
                <div v-if="bundleSavingsIsGreaterThanZero" class="product-suggest_bundle-savings">
                    Bundle Savings ${{ item.bundleSavings }}
                </div>
                <div v-else-if="showBundleSavings" class="product-suggest_bundle-savings">
                    Recommended Combo!
                </div>
                <div v-if="showInStockNotice && item.inStock">
                    <strong class="product-suggest__item-instock">
                        <svg class="svg-icon check-circle-stroke" xmlns="http://www.w3.org/2000/svg"><use xlink:href="/include/svg/map.svg#check-circle-stroke"></use></svg> In Stock!
                    </strong>
                </div>
                <div class="product-suggest__item-current" v-if="current">This item:</div>
                <div v-if="wideImage" class="product-suggest__item-wideimage">
                    <img :src="wideImage" class="product-suggest__wide-image" alt="" />
                </div>
                <div v-else class="product-suggest__item-imgwrap">
                    <div v-if="certifiedLevel" class="product-suggest__item-certfit">
                        <img src="https://media.sweetwater.com/m/include/svg/logo-certified-fit-green.svg" alt="Certified Fit Guarantee">
                    </div>
                    <div v-else-if="showBadgeChips && (!!badgeOverrideText || item.badge?.text || false)"
                        class="product-suggest__item-badge"
                        :class="badgeOverrideClass || item.badge.class || ''"
                        :style="item.badge.style || ''"
                    >
                        <span>{{ badgeOverrideText || item.badge.text }}</span>
                    </div>
                    <div v-else-if="item.imageBadge && item.imageBadge !== 'original'">
                        <img :src="`https://media.sweetwater.com/m/images/badges/${item.imageBadge}.png`" class="product-suggest__item-imgbadge" :alt="item.imageBadge" onerror="this.style.display='none'; this.onerror=null;">
                    </div>
                    <img
                        v-if="item.image300"
                        :src="item.image300"
                        alt=""
                        aria-hidden="true"
                        :width="naturalWidth"
                        :height="naturalHeight"
                        ref="productImage"
                        class="product-suggest__item-image"
                        data-testid="suggest_item_img"
                        loading="lazy"
                        decoding="async"
                    />
                    <svg
                        v-else
                        :width="naturalWidth"
                        :height="naturalHeight"
                        viewBox="0 0 300 300"
                        class="product-suggest__item-image product-suggest__item-image--placeholder"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-label="Image placeholder"
                    >
                        <rect width="100%" height="100%" rx="8" ry="8" />
                    </svg>
                </div>
                <div class="product-suggest__item-content">

                    <div class="product-suggest__item-callout" v-if="item.callout" v-html="item.callout"></div>

                    <div class="product-suggest__item-deal-text" v-if="productCallout && showProductCallout" v-html="productCallout"></div>

                    <p class="product-suggest__item-name" 
                        v-show="item.productName && !isGuitarService" 
                        data-testid="suggest_item_name" 
                        :id="nameId"
                    >
                        <strong>{{ item.manufacturer.name || item.manufacturer }}</strong> {{ item.productName }}
                    </p>

                    <div v-if="item.matchType" v-html="item.matchType" class="product-suggest__internal" data-testid="suggest_item_internal_info" aria-hidden="true"></div>

                    <div style="font-size:1.5em" v-if="isGuitarService" class="product-suggest__name">
                        {{ item.manufacturer.name || item.manufacturer }} {{ item.productName }}
                    </div>
                    <div 
                        v-if="showPrice" 
                        class="product-suggest__item-price" 
                        :class="{'has-special-offer': showSpecials && (item.specialOfferValue || (showWasPrice && wasPrice)) && item.specialOfferTitle}" 
                        data-testid="suggest_item_price"
                        :id="priceId"
                    >
                        <currency :amount="item.finalPrice"></currency>
                        <del v-if="showWasPrice && wasPrice">
                            <span class="visually-hidden">was </span>
                            <currency :amount="wasPrice"></currency>
                        </del>
                        <span class="product-suggest__item-shipping" v-if="item.hasFreeShipping && showFreeShippingMsg">
                            + <strong>FREE</strong> Shipping
                        </span>
                    </div>
                    <div v-if="item.bonusBucks && item.bonusBucks !== false" class="bonus-bucks-rewards__container">
                        <div class="bonus-bucks-rewards__inner">
                            <strong v-if="item.bonusBucks.deal">{{item.bonusBucks.deal}}</strong>
                            Add this {{itemType}} and get
                            <span class="nowrap">
                                <span class="bonus-bucks-rewards__value">${{item.bonusBucks.price}}</span>
                                in <a class="bonus-bucks-rewards__link" href="/shop/bonus-bucks/">Bonus Bucks!</a>
                            </span>
                        </div>
                    </div>
                    <div class="product-suggest__item-reviews" v-if="item.averageStarRating && item.averageStarRating >= 3" data-testid="suggest_item_reviews" :id="ratingId">
                        <rating-stars :rating="item.averageStarRating" :review-count="item.totalReviews" size="md" />
                        <span class="product-suggest__item-review-count-inline review__count" v-if="item.totalReviews && inlinereviewnum" aria-hidden="true">({{ item.totalReviews }})</span>
                        <span class="product-suggest__item-review-count review__count" v-if="item.totalReviews && !inlinereviewnum" aria-hidden="true">{{ item.totalReviews }} {{ item.totalReviews === 1 ? 'review' : 'reviews' }}</span>
                    </div>
                    <div class="product-suggest__long-description" v-if="longDescription" v-html="longDescription" :data-description-id="item.itemid">
                    </div>  
                    
                    <div class="product-suggest__rebates" v-if="showSpecials && item.specialOfferTitle" v-html="item.specialOfferTitle"></div>
                    <div class="product-suggest__financing" v-if="showFinancing && item.financingText" v-html="item.financingText" data-testid="suggest_item_financing"></div>
                </div>
            </div>
        </a>
        <div v-if="showMoreDetailsButton" v-on:focus='tabFocus' class="product-suggest__button-wrap vmd">
            <button @click.prevent="itemClicked" tabindex="0" class="btn btn--small view-more-details">View More Details</button>  
        </div>
        <div v-if="showAddToCartButton && !item.hideBuyButton" v-on:focus='tabFocus' class="product-suggest__button-wrap">
            <template v-if="isCategoryFeed">
                <a v-show="!buttonToggled" :href="`/store/cart.php?action=additem&itemid=${item.itemid}`" class="btn add-to-cart">{{ addToCartButtonText }}</a>
                <div v-show="buttonToggled" class="btn added-to-cart">Added to Cart</div>
            </template>
            <template v-else>
                <button v-show="!buttonToggled" @click.prevent="addToCart" tabindex="0" class="btn add-to-cart">{{ addToCartButtonText }}</button>
                <div v-show="buttonToggled" tabindex="0" class="btn added-to-cart">Added to Cart</div>
            </template>
        </div>
        <!-- Show PDP button if add to cart is not available -->
        <div v-else-if="showAddToCartButton" v-on:focus='tabFocus' class="product-suggest__button-wrap">
            <template v-if="isCategoryFeed">
                <a :href="item.url" class="btn add-to-cart">See Details</a>
            </template>
            <template v-else>
                <button @click.prevent="goToPDP" tabindex="0" class="btn add-to-cart">See Details</button>
            </template>
        </div>
    </div>
</template>

<script>
    require('@sweetwater/lazyloader/vue-directive');

    export default {
        props: {
            item: {
                type: Object,
                required: true,
            },
            current: {
                type: Boolean,
                required: false,
                default: false,
            },
            loggingAction: {
                type: String,
                required: false,
                default: null,
            },
            showFinancing: {
                type: Boolean,
                default: false,
                required: false,
            },
            showSpecials: {
                type: Boolean,
                default: false,
                required: false,
            },
            showAddToCartButton: {
                type: Boolean,
                required: false,
                default: false,
            },
            showMoreDetailsButton: {
                type: Boolean,
                required: false,
                default: false,
            },
            showBundleSavings: {
                type: Boolean,
                required: false,
                default: false,
            },
            showProductCallout: {
                type: Boolean,
                required: false,
                default: true,
            },
            addToCartButtonText: {
                type: String,
                required: false,
                default: 'Add to Cart',
            },
            showInStockNotice: {
                type: Boolean,
                required: false,
                default: false,
            },
            tag: {
                type: String,
                required: false,
                default: 'li',
            },
            showFreeShippingMsg: {
                default: true,
                type: Boolean,
            },
            showCertifiedFitCases: {
                default: true,
                type: Boolean,
                required: false,
            },
            sliderHasStarRatings: {
                default: false,
                type: Boolean,
                required: false,
            },
            sliderHasPromos: {
                default: false,
                type: Boolean,
                required: false,
            },
            inlinereviewnum: {
                default: false,
                type: Boolean,
                required: false,
            },
            isCategoryFeed: {
                type: Boolean,
                required: false,
                default: false,
            },
            feedIdentifier: {
                default: 'recommended',
                required: false,
                type: String,
            },
            badgeOverrideText: {
                type: [String, null],
                required: false,
                default: null,
            },
            badgeOverrideClass: {
                type: [String, null],
                required: false,
                default: null,
            },
            showBadgeChips: {
                type: Boolean,
                required: false,
                default: false,
            },
            isCompareItem: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                buttonToggled : false,
                longDescription: '',
                wideImage: '',
                isGuitarService: '',
                showButton: false,
                naturalWidth: 300,
                naturalHeight: 300,
                a11yUid: `ps-${this._uid}`,
            }
        },
        mounted(){
            this.$root.$on("recommendedUpsellClicked", this.buttonAddedState);
            switch (this.item.parentId) {
                case 'InstallGSU':
                    this.longDescription = 'Put our Guitar Workshop to work setting up your new guitar to your specifications. Action height, neck relief, and intonation will all be gone over with incredible precision, ensuring your new guitar plays just the way you like it.';
                    this.wideImage = 'https://media.sweetwater.com/m/images/store/cart/guitarServiceBannerSetup.jpg';
                    this.isGuitarService = true;

                break;
                case 'InstallGSUT':
                    this.longDescription = 'Put our Guitar Workshop to work setting up your new guitar to your specifications. Action height, neck relief, and intonation will all be gone over with incredible precision, ensuring your new guitar plays just the way you like it.'
                    this.wideImage = 'https://media.sweetwater.com/m/images/store/cart/guitarServiceBannerSetup.jpg';
                    this.isGuitarService = true;

                break;
                case 'InstallGSULT':
                    this.longDescription = 'Put our Guitar Workshop to work setting up your new guitar to your specifications. Action height, neck relief, and intonation will all be gone over with incredible precision, ensuring your new guitar plays just the way you like it.'
                    this.wideImage = 'https://media.sweetwater.com/m/images/store/cart/guitarServiceBannerSetup.jpg';
                    this.isGuitarService = true;

                break;
                case 'InstallGNutT':
                    this.longDescription = 'If you want to ensure the best tuning stability possible for your new guitar, you definitely want to consider having our Guitar Workshop outfit the instrument with a custom TUSQ nut. Not only does this material help keep you in tune, but you’ll also notice increased sustain. <br aria-hidden=\"true\"><b>(Includes Custom Setup)</b>'
                    this.wideImage = 'https://media.sweetwater.com/m/images/store/cart/guitarServiceBannerTusq.jpg';
                    this.isGuitarService = true;

                break;
                case 'InstallGNutT12':
                    this.longDescription = 'If you want to ensure the best tuning stability possible for your new guitar, you definitely want to consider having our Guitar Workshop outfit the instrument with a custom TUSQ nut. Not only does this material help keep you in tune, but you’ll also notice increased sustain. <br aria-hidden=\"true\"><b>(Includes Custom Setup)</b>'
                    this.wideImage = 'https://media.sweetwater.com/m/images/store/cart/guitarServiceBannerTusq.jpg';
                    this.isGuitarService = true;

                break;
                case 'InstallGNutB':
                    this.longDescription = 'You’ll be amazed by the sonic difference that a properly installed bone nut will make on your new guitar. Have us add one that is custom-fitted to your guitar, and you’ll be enjoying increased sustain and a more pristine tone as soon as you get the instrument in your hands. <br aria-hidden=\"true\"><b>(Includes Custom Setup)</b>'
                    this.wideImage = 'https://media.sweetwater.com/m/images/store/cart/guitarServiceBannerBone.jpg';
                    this.isGuitarService = true;

                break;
                case 'InstallGNutB12':
                    this.longDescription = 'You’ll be amazed by the sonic difference that a properly installed bone nut will make on your new guitar. Have us add one that is custom-fitted to your guitar, and you’ll be enjoying increased sustain and a more pristine tone as soon as you get the instrument in your hands. <br aria-hidden=\"true\"><b>(Includes Custom Setup)</b>'
                    this.wideImage = 'https://media.sweetwater.com/m/images/store/cart/guitarServiceBannerBone.jpg';
                    this.isGuitarService = true;

                break;
                case 'InstallGPlek':
                    this.longDescription = 'The most precise fretwork on the planet, our Plek process uses the latest in technology to give your new guitar perfectly leveled frets, a hand-polished feel, and low action without fret buzz that needs to be experienced to be believed.'
                    this.wideImage = 'https://media.sweetwater.com/m/images/store/cart/guitarServiceBannerPlek.jpg';
                    this.isGuitarService = true;

                break;

            }

            if (window.itemsInCart && Array.isArray(window.itemsInCart)) {
                this.buttonToggled = window.itemsInCart.includes(this.item.itemid);
            }

            this.setImageDimensions();
        },
        beforeDestroy(){
            this.$root.$off("recommendedUpsellClicked", this.buttonAddedState)
        },
        methods: {
            addToCart() {
                this.$emit('addToCart', this.item);
                this.lockFocus();
            },
            goToPDP(event) {
                if (event) event.preventDefault();
                window.location.href = this.item.url;
            },
            itemClicked(event) {
                this.$emit('itemClicked', this.item);
                if (event.metaKey || event.ctrlKey) {
                    return;
                }
                event.preventDefault();
                setTimeout(() => {
                    window.location.href = this.itemUrl;
                }, 300);
            },
            buttonAddedState(itemId) {
                if(itemId === this.itemId) {
                    this.buttonToggled = !this.buttonToggled
                }
            },
            tabFocus(event) {
                this.showButton = true;
                const focusedEl = document.activeElement, // element receiving focus
                feWidth = focusedEl.clientWidth, // general focused-el width
                {left, right} = focusedEl.getBoundingClientRect(), // left and right coords of focused-el bounding rectangle
                parentContainer = focusedEl.closest('.product-suggest'); // top level parent container for the focused-el
                if (parentContainer) {
                    const itemScroller = focusedEl.closest('.product-suggest__items'), // item scroll area
                    parentContainerRect = parentContainer.getBoundingClientRect(), // coords object for parent container
                    inViewRight = Math.abs(right - parentContainerRect.right), // representative value for how much of the focused-el is in view to the right
                    inViewLeft = Math.abs(left - parentContainerRect.left); // representative value for how much of the focused-el is in view to the left
                    // Tabbing right, is item out of view to the right?
                    if (inViewRight < feWidth && !event.shiftKey) {
                        // calculate how much of the image we're not seeing + the size of the largest nav button's width and add it to scrollLeft
                        itemScroller.scrollLeft += ((feWidth - inViewRight) + 80); // 80 is the width of the slider navigation button(s) when present, but also a helpful padding value to make sure the item is fully in view and not covered by these elements

                        // if these conditions are true, we don't need to check the left side
                        return; 
                    }

                    // Shift-tabbing left, is item out of view to the left?
                    if (inViewLeft < feWidth && event.shiftKey) {
                        // calculate how much of the image we're not seeing + the size of the largest nav button's width and subtract it from scrollLeft
                        itemScroller.scrollLeft -= ((feWidth - inViewLeft) + 80); // same as above
                    }  
                }
            },
            lockFocus () {
                this.$nextTick(() => {
                    const modal = document.querySelector('.modal--recommendation'),
                    focusable = modal?.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

                    if (!focusable) {
                        return;
                    }

                    const firstFocusable = focusable[0],
                          lastFocusable = focusable[focusable.length - 1];

                    if(firstFocusable){
                        firstFocusable.focus();
                    }

                    firstFocusable.addEventListener('keydown', function(e){
                        if (e.shiftKey && e.key === 'Tab') {
                            e.preventDefault();
                            lastFocusable.focus();
                        }
                    })

                    lastFocusable.addEventListener('keydown', function(e){
                        if (e.key === 'Tab' && !e.shiftKey) {
                            e.preventDefault();
                            firstFocusable.focus();
                        }
                    })
                    
                }, 100);
            },
            setImageDimensions() {
                const img = this.$refs.productImage;
                if (img) {
                    img.onload = () => {
                        this.naturalWidth = img.naturalWidth;
                        this.naturalHeight = img.naturalHeight;
                    }
                }
            }
        },
        computed: {
            nameId() {
                return `${this.a11yUid}-name`;
            },
            productName() {
                const manufacturer = this.item.manufacturer?.name || (typeof this.item.manufacturer === 'string' ? this.item.manufacturer : '');
                return [manufacturer, this.item.productName].filter(Boolean).join(' ');
            },
            productLinkAriaLabel() {
                return this.productName ? `Product Link: ${this.productName}` : 'Product Link';
            },
            priceId() {
                return `${this.a11yUid}-price`;
            },
            ratingId() {
                return `${this.a11yUid}-rating`;
            },
            describedByIds() {
                const ids = [];
                if (this.showPrice) ids.push(this.priceId);
                if (this.item.averageStarRating && this.item.averageStarRating >= 3) ids.push(this.ratingId);
                return ids.length ? ids.join(' ') : null;
            },
            bundleSavingsIsGreaterThanZero() {
                return this.showBundleSavings && this.item.bundleSavings > 0;
            },
            itemId() {
                return this.item.itemid
            },
            itemUrl() {
                let certFit = this.certifiedLevel ? `?certfit${this.certifiedLevel}` : '';

                return this.item.url + certFit;
            },
            certifiedLevel() {
                switch (this.item.certifiedFit) {
                    case 'everyday':
                        return 'a';
                    case 'tour':
                        return 'b';
                    default:
                        return null;
                }
            },
            resolveFeedIdentifier() {
                return this.feedIdentifier === '' ? 'recommended' : this.feedIdentifier;
            },
            shouldShowItem() {
                return !this.item.certifiedFit || this.showCertifiedFitCases; // optionally filter cert fit cases
            },
            productCallout() {
                if(this.item.certifiedFit){
                    return 'It\'s a Certified Fit!!';
                } else if(this.item.headline){
                    return this.item.headline;
                }
            },
            itemType() {
                return (this.isGuitarService ? 'service' : 'item');
            },
            showPrice() {
                return typeof this.item.finalPrice === 'number' && this.item.finalPrice > 0 && this.item.finalPrice !== 88888;
            },
            showWasPrice() {
                if (!this.showPrice) return false;
                const hasPriceDrop = this.item.hasPriceDrop && this.item.basePrice > 0 && this.item.basePrice > this.item.finalPrice;
                const hasSpecialOffer = this.item.specialOfferValue > 0 && this.item.specialOfferTitle?.includes('Price Drop');
                return hasPriceDrop || hasSpecialOffer;
            },
            wasPrice() {
                if (!this.showWasPrice) return null;
                if (this.item.basePrice > 0 && this.item.basePrice > this.item.finalPrice) {
                    return this.item.basePrice;
                }
                if (Number(this.item.specialOfferValue) > 0 && Number(this.item.finalPrice) > 0) {
                    return Number(this.item.specialOfferValue) + Number(this.item.finalPrice);
                }
                return null;
            },
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss" type="text/scss">
    @import '~@sweetwater/sass-resources/sass';
    @import '../../css/app/utility/ratings';

    .cart-modal li.product-suggest__item-wrap {
        overflow: hidden;
    }

    a.product-suggest__item {
        padding-top: 0;

        &.has-wide-image {
            outline: 0;
            margin: 0;
            padding: 0;

            .product-suggest__item-content {
                outline-offset: 2px;
            }

            &:focus .product-suggest__item-content {
                outline: 2px solid $blue;
            }
        }

        .product-suggest__item-name strong,
        .product-suggest__item-shipping strong {
            font-weight: 600;
        }
    }

    .btn.view-more-details {
        opacity: 1;
        margin: 10px 0;
        border: 1px solid var(--black);
        height: 40px;
        width: 100%;
        max-width: 80%;
        align-self: flex-end;
        background: #fff;
        transition: opacity 150ms ease-in-out;
        @include media('>=small') {
            opacity: 0;
        }
        &:hover {
            background: var(--black);
            color: #fff;
        }
    }

    .bonus-bucks-rewards__container {
        background: #ffeb8a;
        color: #2e2e2d;
        font-family: 'Sweetwater', 'Aspira', sans-serif;
        font-size: 1.1em;
        font-weight: 400;
        line-height: 1.33;
        margin: 10px auto 0;
        max-width: 400px;
        padding: 10px 5px 30px;
        position: relative;
    }

    .bonus-bucks-rewards__container:after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: -1px;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-bottom: 22px solid #fff;
        border-left: 200px solid transparent;
        border-right: 200px solid transparent;
    }

    .bonus-bucks-rewards__inner {
        margin: 0 auto;
        text-align: center;
    }

    .bonus-bucks-rewards__inner strong {
        color: #316916;
        display: block;
        font-weight: 600;
        text-transform: uppercase;
    }

    .bonus-bucks-rewards__inner .nowrap {
        white-space: nowrap;
    }

    .bonus-bucks-rewards__value {
        color: #316916;
        font-weight: 800;
    }

    .bonus-bucks-rewards__container a.bonus-bucks-rewards__link {
        color: #316916 !important;
        font-weight: 600;
        text-decoration: underline;
    }

    @media all and (max-width: 768px) {
        .bonus-bucks-rewards__container {
            font-size: 1.3em;
        }
    }
    .pdp-recommends h5 {
        line-height: 1.2em;
        font-size: 14px;
        padding-top: .5em;
    }

    .product-suggest__button-wrap {
        display: flex;
        justify-content: center;
        margin-top: auto;
        width: 100%;
        &:last-child {
            margin-top: 0;
        }
        &.vmd {
            display: none;
        }
    }

    .product-suggest__rebates,
    .product-suggest__financing {
        -webkit-box-orient: vertical;
        color: var(--red);
        display: -webkit-box;
        font-size: 1rem;
        font-weight: 700;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        margin: 0.25rem 0 0.75rem;
        overflow: hidden;
        text-align: left;
        text-overflow: ellipsis;

        @include media('<=xsmall') {
            font-size: 0.875rem;
        }

        + .product-suggest__button-wrap {
            margin: 0;
        }
    }

    .hover-atc {
        .btn.add-to-cart {
        background: #3b7d1a;
        border-color: #3b7d1a;
        box-sizing: border-box;
        color: #fff;
        display: none;
        max-width: 80%;
        opacity: 0;
        outline: none;
        padding: 1em;
        width: 100%;
        transition: .15s opacity;
        font-size: 13px;
        height: 40px;
        margin-top: 5px;
            &:hover {
                background: #316816;
            }
        }
        .btn.added-to-cart {
            background: #fff;
            border: 1px solid #4E8410;
            box-sizing: border-box;
            color: #4E8410!important;
            display: none;
            font-weight: 600;
            padding: 1em;
            width: 100%;
            max-width: 80%;
            font-size: 13px;
            height: 40px;
            margin-top: 5px;
            cursor: default;
            &:before {
                content:'';
                align-content: center;
                border: 2px solid #4E8410;
                border-top: none;
                border-right: none;
                display: inline-block;
                margin-right: 10px;
                margin-bottom: 1px;
                width: 1.1em;
                height: .7em;
                transform: rotate(-45deg);
            }
            &:hover {
                background: #fff;
                cursor: default;
            }
        }
        .btn.btn--modal-grey {
            display: none;
        }
        .product-suggest__item-wrap:hover button.btn,
        .product-suggest__item:focus button.btn {
            opacity: 1;
        }     
        button.btn:focus {
            opacity: 1;
            outline: 1px solid blue !important;
            outline: 5px auto -webkit-focus-ring-color;
            outline-offset: 2px;
        }
        .product-suggest__item:focus-visible ~ .product-suggest__button-wrap .btn {
            opacity: 1;
        }
        
    }
    @media all and (max-width: 720px) {
        .hover-atc {
            .btn.added-to-cart {
                display: none;
            }
            .btn.btn--modal-grey {
                display: none;
            }
            .product-suggest__item-wrap:hover button.btn {
                display: none;
            }
        }
    }
</style>
